module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exam_detail_box"
  }, [_c('div', {
    staticClass: "bg_box"
  }), _vm._v(" "), _c('div', {
    staticClass: "exam_detail_top"
  }, [_c('div', {
    staticClass: "exam_msg_t"
  }, [_c('p', {
    staticClass: "exam_msg_tl"
  }, [_vm._v(_vm._s(_vm.examinfoData.title))])]), _vm._v(" "), _c('div', {
    staticClass: "exam_msg_b"
  }, [(_vm.examinfoData.startTime || _vm.examinfoData.endTime) ? _c('p', [_vm._v("报名时间：" + _vm._s(_vm.examinfoData.startTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : _vm.examinfoData.startTime.substring(0, 16)) + "~" + _vm._s(_vm.examinfoData.endTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : _vm.examinfoData.endTime.substring(0, 16)))]) : _vm._e(), _vm._v(" "), (_vm.examinfoData.doTime) ? _c('p', [_vm._v("考试时间：" + _vm._s(_vm.examinfoData.doTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : _vm.examinfoData.doTime.substring(0, 16)))]) : _vm._e(), _vm._v(" "), (_vm.examinfoData.checkTime) ? _c('p', [_vm._v("查询时间：" + _vm._s(_vm.examinfoData.checkTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : _vm.examinfoData.checkTime.substring(0, 16)))]) : _vm._e(), _vm._v(" "), (_vm.examinfoData.isRemind) ? _c('p', [_vm._v("提醒方式：" + _vm._s(_vm.examinfoData.remindType))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "detail_info_box",
    domProps: {
      "innerHTML": _vm._s(_vm.examinfoData.content)
    }
  }), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 1
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-57515c74"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/examdetail.vue
// module id = 697
// module chunks = 1